// locale-unextracted-ignore-file
import { SimpleTable } from '@app/components/base/SimpleTable';
import { Typography } from '@mui/material';
import { fixedWidthColumnProps } from './hls-timeline-fixed-table';
import { formatBytes, formatSeconds } from './hls-timeline-stats';
import { HlsTimelinePlaylistRow } from './hls-timeline-stats-types';

type HlsTimelinePlaylistRowsTableProps = {
  rows: HlsTimelinePlaylistRow[];
};

const PLAYLIST_KIND_LABELS: Record<HlsTimelinePlaylistRow['playlistKind'], string> = {
  level: 'Level',
  audioTrack: 'Audio',
  subtitleTrack: 'Subtitles',
};

/** Tabular view of HLS playlist rows (levels, audio, subtitles) from the timeline chart. */
export function HlsTimelinePlaylistRowsTable({ rows }: HlsTimelinePlaylistRowsTableProps) {
  return (
    <>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5, fontWeight: 'bold' }}
      >
        Playlists — {rows.length} row{rows.length === 1 ? '' : 's'}
      </Typography>
      <SimpleTable
        fixedLayout
        columns={[
          {
            header: 'Row',
            renderCell: (row) => row.label,
            ...fixedWidthColumnProps('20%'),
          },
          {
            header: 'Type',
            renderCell: (row) => PLAYLIST_KIND_LABELS[row.playlistKind],
            ...fixedWidthColumnProps('7%'),
          },
          {
            header: 'Fragments',
            renderCell: (row) => row.fragmentCount,
            ...fixedWidthColumnProps('7%'),
          },
          {
            header: 'Parts',
            renderCell: (row) => row.partCount,
            ...fixedWidthColumnProps('7%'),
          },
          {
            header: 'Loaded',
            renderCell: (row) => `${row.loadedFragments}/${row.fragmentCount}`,
            ...fixedWidthColumnProps('7%'),
          },
          {
            header: 'Buffered',
            renderCell: (row) => formatBytes(row.bufferedBytes),
            ...fixedWidthColumnProps('9%'),
          },
          {
            header: 'Downloaded',
            renderCell: (row) => formatBytes(row.loadedBytes),
            ...fixedWidthColumnProps('9%'),
          },
          {
            header: 'Total',
            renderCell: (row) => formatBytes(row.totalBytes),
            ...fixedWidthColumnProps('9%'),
          },
          {
            header: 'Duration',
            renderCell: (row) => formatSeconds(row.playlistDuration),
            ...fixedWidthColumnProps('8%'),
          },
          {
            header: 'Target',
            renderCell: (row) => formatSeconds(row.targetDuration),
            ...fixedWidthColumnProps('8%'),
          },
          {
            header: 'Live',
            renderCell: (row) => (row.live == null ? '—' : row.live ? 'yes' : 'no'),
            ...fixedWidthColumnProps('5%'),
          },
          {
            header: 'Active',
            renderCell: (row) => (row.isActive ? 'yes' : 'no'),
            ...fixedWidthColumnProps('5%'),
          },
        ]}
        data={rows}
      />
    </>
  );
}
